import { render, staticRenderFns } from "./SignAuthorizationInfo.vue?vue&type=template&id=23887aa1&scoped=true"
import script from "./SignAuthorizationInfo.vue?vue&type=script&lang=js"
export * from "./SignAuthorizationInfo.vue?vue&type=script&lang=js"
import style0 from "./SignAuthorizationInfo.vue?vue&type=style&index=0&id=23887aa1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23887aa1",
  null
  
)

export default component.exports